import type { ReactNode } from 'react';

export function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className="sk:flex sk:flex-col sk:gap-2">
      <h2 className="sk:font-semibold">{title}</h2>
      {children}
    </section>
  );
}
